import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    vehicles: {
      status: null,
      data: [],
      error: null,
    },
    vehiclePricesList: {
      status: null,
      data: [],
      error: null,
    },
    vehiclePrice: {
      status: null,
      data: null,
      error: null,
    },
    providersList: {
      dates: null,
      status: null,
      data: [],
      error: null,
    },
    vehiclesPriceBySupplier: {
      status: null,
      data: [],
      error: null,
    },
    priceXLS: {
      status: null,
      data: null,
      error: null,
    },
    coincidences: {
      status: null,
      data: {
        internal: [],
        external: []
      },
      error: null,
    },
    coincidencesXLS: {
      status: null,
      data: null,
      error: null,
    },
  }
}

const actions = {
  [constants.GET_VEHICLES_LIST_PROVIDER_PRICE]: async ({ commit }, params) => {
    try {
      commit(constants.GET_VEHICLES_LIST_PROVIDER_PRICE);

      const response = await axios.get(`supplier/getVehicles`, { params: { ...params } });
      commit(constants.GET_VEHICLES_LIST_PROVIDER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_VEHICLES_LIST_PROVIDER_PRICE_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID]: async ({ commit }, params) => {
    try {
      commit(constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID);

      const response = await axios.get(`supplier/findPriceByVehicles`, { params: { ...params } });
      commit(constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID_ERROR, error);
      throw error.response;
    }
  },
  [constants.DELETE_VEHICLE_PROVIDER_PRICE]: async ({ commit }, params) => {
    try {
      commit(constants.DELETE_VEHICLE_PROVIDER_PRICE);

      const response = await axios.delete(`supplier/deleteVehicleSuppliers`, { params: { ...params } });
      commit(constants.DELETE_VEHICLE_PROVIDER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.DELETE_VEHICLE_PROVIDER_PRICE_ERROR, error);
      throw error.response;
    }
  },
  [constants.POST_VEHICLE_PROVIDER_PRICE]: async ({ commit }, params) => {
    try {
      commit(constants.POST_VEHICLE_PROVIDER_PRICE);
      const response = await axios.post(`supplier/assignSupplierToVehicle`, params);
      commit(constants.POST_VEHICLE_PROVIDER_PRICE_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.POST_VEHICLE_PROVIDER_PRICE_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_SUPPLIERS_LIST]: async ({ commit }, params) => {
    try {
      commit(constants.GET_SUPPLIERS_LIST);

      const response = await axios.get(`supplier/getLists`, { params: { ...params } });
      commit(constants.GET_SUPPLIERS_LIST_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_SUPPLIERS_LIST_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_PRICE_BY_PROVIDER]: async ({ commit }, params) => {
    try {
      commit(constants.GET_PRICE_BY_PROVIDER);

      const response = await axios.get(`supplier/findPriceBySuppliers`, { params: { ...params } });
      commit(constants.GET_PRICE_BY_PROVIDER_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_PRICE_BY_PROVIDER_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_PRICE_XLS]: async ({ commit }, params) => {
    try {
      commit(constants.GET_PRICE_XLS);

      const response = await axios.get(`supplier/generateExcelPrices`, {
        params: { ...params }, responseType: 'blob'
      });
      commit(constants.GET_PRICE_XLS_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_PRICE_XLS_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_COINCIDENCES_XLS]: async ({ commit }, params) => {
    try {
      commit(constants.GET_COINCIDENCES_XLS);
      const response = await axios.get(`supplier/generateExcel`, {
        params: { ...params },
        responseType: 'blob'
      });
      commit(constants.GET_COINCIDENCES_XLS_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_COINCIDENCES_XLS_ERROR, error);
      throw error.response;
    }

  },

}


const mutations = {
  [constants.GET_VEHICLES_LIST_PROVIDER_PRICE](state) {
    state.vehicles.status = "fetching";
    state.vehicles.data = null;
    state.vehicles.error = null;
    state.coincidences.data = {
      internal: [],
      external: []
    };

  },
  [constants.GET_VEHICLES_LIST_PROVIDER_PRICE_SUCCESS](state, response) {
    state.vehicles.status = "success";
    state.vehicles.data = response.vehicle;
    state.coincidences.data.internal = response.internalVehicles || [];
    state.coincidences.data.external = response.externalVehicles || [];
    state.vehicles.error = null;
  },
  [constants.GET_VEHICLES_LIST_PROVIDER_PRICE_ERROR](state, error) {
    state.vehicles.status = "error";
    state.vehicles.error = error;
  },

  [constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID](state) {
    state.vehiclePricesList.status = "fetching";
    state.vehiclePricesList.data = [];
    state.vehiclePricesList.dates = [];
  },
  [constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID_SUCCESS](state, response) {
    state.vehiclePricesList.status = "success";
    state.vehiclePricesList.data = response.data;
    state.vehiclePricesList.dates = response.dates || [];
  },
  [constants.GET_VEHICLES_PROVIDER_PRICE_BY_ID_ERROR](state, error) {
    state.vehiclePricesList.status = "error";
    state.vehiclePricesList.error = error;

  },
  [constants.DELETE_VEHICLE_PROVIDER_PRICE](state) {
    state.vehiclePrice.status = "fetching";
  },
  [constants.DELETE_VEHICLE_PROVIDER_PRICE_SUCCESS](state, response) {
    state.vehiclePrice.status = "success";
    state.vehiclePrice.data = response;
  },
  [constants.DELETE_VEHICLE_PROVIDER_PRICE_ERROR](state, error) {
    state.vehiclePrice.status = "error";
    state.vehiclePrice.error = error;
  },
  [constants.POST_VEHICLE_PROVIDER_PRICE](state) {
    state.vehiclePrice.status = "fetching";
  },
  [constants.POST_VEHICLE_PROVIDER_PRICE_SUCCESS](state, response) {
    state.vehiclePrice.status = "success";
    state.vehiclePrice.data = response;
  },
  [constants.POST_VEHICLE_PROVIDER_PRICE_ERROR](state, error) {
    state.vehiclePrice.status = "error";
    state.vehiclePrice.error = error;
  },
  [constants.GET_SUPPLIERS_LIST](state) {
    state.providersList.status = "fetching";
  },
  [constants.GET_SUPPLIERS_LIST_SUCCESS](state, response) {
    state.providersList.status = "success";
    state.providersList.data = response;
  },
  [constants.GET_SUPPLIERS_LIST_ERROR](state, error) {
    state.providersList.status = "error";
    state.providersList.error = error;
  },
  [constants.GET_PRICE_BY_PROVIDER](state) {
    state.vehiclesPriceBySupplier.status = "fetching";
  },
  [constants.GET_PRICE_BY_PROVIDER_SUCCESS](state, response) {
    state.vehiclesPriceBySupplier.status = "success";
    state.vehiclesPriceBySupplier.data = response.data;
  },
  [constants.GET_PRICE_BY_PROVIDER_ERROR](state, error) {
    state.vehiclesPriceBySupplier.status = "error";
    state.vehiclesPriceBySupplier.error = error;
  },
  [constants.GET_PRICE_XLS](state) {
    state.priceXLS.status = "fetching";
    state.priceXLS.data = null;
    state.priceXLS.error = null;
  },
  [constants.GET_PRICE_XLS_SUCCESS](state, response) {
    state.priceXLS.status = "success";
    state.priceXLS.data = response;
  },
  [constants.GET_PRICE_XLS_ERROR](state, error) {
    state.priceXLS.status = "error";
    state.priceXLS.error = error;
  },

  [constants.GET_COINCIDENCES_XLS](state) {
    state.coincidencesXLS.status = "fetching";
    state.coincidencesXLS.data = null;
    state.coincidencesXLS.error = null;
  },
  [constants.GET_COINCIDENCES_XLS_SUCCESS](state, response) {
    state.coincidencesXLS.status = "success";
    state.coincidencesXLS.data = response;
  },
  [constants.GET_COINCIDENCES_XLS_ERROR](state, error) {
    state.coincidencesXLS.status = "error";
    state.coincidencesXLS.error = error;
  },


}

export default {
  state: getDefaultState(),
  actions,
  mutations,
};